import { render, staticRenderFns } from "./TutorialesCuenta.vue?vue&type=template&id=4bbafafd&scoped=true"
import script from "./TutorialesCuenta.vue?vue&type=script&lang=js"
export * from "./TutorialesCuenta.vue?vue&type=script&lang=js"
import style0 from "./TutorialesCuenta.vue?vue&type=style&index=0&id=4bbafafd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbafafd",
  null
  
)

export default component.exports